import { InjectionToken } from '@angular/core';
import { EnvironmentModel } from './environment.model';

export const EnvironmentConfig = new InjectionToken<EnvironmentModel>(
  "Environment config"
)
